import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2161">
      <About data-id="element-2162" />
    </main>;
}